import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'Visitors Home',
    component: () => import('./views/visitors/home'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters.memberToken) {
          next({ name: 'Member details' })
        } else if(store.getters.isLoggedIn) {
          next({ name: 'home' })
        } else {
          next()
        }
      },
    }
  },
  {
    path: '/visitors/entry',
    name: 'Visitors Entry',
    component: () => import('./views/visitors/entry'),
  },
  {
    path: '/member/details',
    name: 'Member details',
    meta: { memberAuth: true },
    component: () => import('./views/member/details'),
  },
  {
    path: '/member/edit',
    name: 'Member edit',
    meta: { memberAuth: true },
    component: () => import('./views/member/edit'),
  },
  {
    path: '/member/login',
    name: 'Member Login',
    component: () => import('./views/member/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.memberToken) {
          // Redirect to the home page instead
          next({ name: 'Member details' })
        } else {
          // Continue to the login page
          next()
        }
      },
    }
  },
  {
    path: '/member/:mobile/otp',
    name: 'Member Otp',
    component: () => import('./views/member/otp'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.memberToken) {
          // Redirect to the home page instead
          next({ name: 'Member details' })
        } else {
          // Continue to the login page
          next()
        }
      },
    }
  },
  {
    path: '/member/logout',
    name: 'Member Logout',
    meta: {
      memberAuth: true,
      beforeResolve(routeTo, routeFrom, next) {

        store.dispatch('memberLogout')

        next({name: 'Visitors Home'})
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
  {
    path: '/layout/horizontal',
    name: 'Horizontal',
    meta: { authRequired: true },
    component: () => import('./views/layout/horizontal')
  },
]
